import {type IOption, Select} from "@pg-design/select-module";

import {dayNamesArray} from "../constants/day_names_array";
import type {ICalendarDate} from "../types/ICalendarDate";
import type {IHoursOption} from "../types/IHoursOption";
import {getHoursOptions} from "../utils/get_hours_options";

import * as styles from "./HourSelect.module.css";
interface IProps {
    selectedDay?: ICalendarDate;
    onHourChange: (hour: string) => void;
    hourOptions?: IHoursOption[];
    hourSelectPlaceholder?: string;
}

export const HourSelect = (props: IProps) => {
    if (!props.hourOptions || props.hourOptions.length === 0) {
        return null;
    }

    const today = new Date();
    const isToday =
        props.selectedDay &&
        today.getDate() === props.selectedDay.day &&
        today.getMonth() === props.selectedDay.month &&
        today.getFullYear() === props.selectedDay.year;
    const hourOptions = !props.selectedDay ? [] : getHoursOptions(dayNamesArray[props.selectedDay.dayId], props.hourOptions, isToday);

    const isOfficeClose = props.selectedDay && hourOptions.length === 0;
    const deactivateSelect = typeof isOfficeClose === "boolean" && isOfficeClose;

    return (
        <Select
            className={styles.hourSelect}
            controlClassName={styles.hourSelectControl}
            isDisabled={!props.selectedDay || deactivateSelect}
            placeholder={deactivateSelect ? "Biuro nieczynne" : props.hourSelectPlaceholder || "Zaproponuj godzinę"}
            options={hourOptions}
            value={hourOptions?.find((hour) => (props.selectedDay ? hour.value === props.selectedDay.hour : null)) || undefined}
            onChange={(option) => {
                const convertedOption = option as IOption<string>;

                if (convertedOption?.value) {
                    props.onHourChange(convertedOption.value);
                }
            }}
        />
    );
};
import {type IOption, Select} from "@pg-design/select-module";

import {dayNamesArray} from "../constants/day_names_array";
import type {ICalendarDate} from "../types/ICalendarDate";
import type {IHoursOption} from "../types/IHoursOption";
import {getHoursOptions} from "../utils/get_hours_options";

import * as styles from "./HourSelect.module.css";
interface IProps {
    selectedDay?: ICalendarDate;
    onHourChange: (hour: string) => void;
    hourOptions?: IHoursOption[];
    hourSelectPlaceholder?: string;
}

export const HourSelect = (props: IProps) => {
    if (!props.hourOptions || props.hourOptions.length === 0) {
        return null;
    }

    const today = new Date();
    const isToday =
        props.selectedDay &&
        today.getDate() === props.selectedDay.day &&
        today.getMonth() === props.selectedDay.month &&
        today.getFullYear() === props.selectedDay.year;
    const hourOptions = !props.selectedDay ? [] : getHoursOptions(dayNamesArray[props.selectedDay.dayId], props.hourOptions, isToday);

    const isOfficeClose = props.selectedDay && hourOptions.length === 0;
    const deactivateSelect = typeof isOfficeClose === "boolean" && isOfficeClose;

    return (
        <Select
            className={styles.hourSelect}
            controlClassName={styles.hourSelectControl}
            isDisabled={!props.selectedDay || deactivateSelect}
            placeholder={deactivateSelect ? "Biuro nieczynne" : props.hourSelectPlaceholder || "Zaproponuj godzinę"}
            options={hourOptions}
            value={hourOptions?.find((hour) => (props.selectedDay ? hour.value === props.selectedDay.hour : null)) || undefined}
            onChange={(option) => {
                const convertedOption = option as IOption<string>;

                if (convertedOption?.value) {
                    props.onHourChange(convertedOption.value);
                }
            }}
        />
    );
};
